var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"slider-stars"}},[_c('vue-slider',_vm._b({staticClass:"raleway-reg-p15",model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'vue-slider',_vm.options,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }